import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { transferAccountConfirmNumberValidation } from './TransferAccountConfirmNumber.validation';
import { useInitiateAccountTransferMutation } from '../../../api/useInitateAccountTransferMutation';
import { useTransferMoneyContext } from '../../../hooks/useTransferMoneyContext';

interface UseTransferAccountConfirmNumberParams {
  selectedAccountId: string;
}

interface FormValues {
  accountNumber: string;
}

export const useTransferAccountConfirmNumber = ({
  selectedAccountId,
}: UseTransferAccountConfirmNumberParams) => {
  const { clientId, managedAccountId } = useTransferMoneyContext();

  const [showSuccessScreen, setShowSuccessScreen] = useState(false);

  const formBag = useForm<FormValues>({
    defaultValues: {
      accountNumber: '',
    },
    resolver: yupResolver(transferAccountConfirmNumberValidation),
  });

  const initiateAccountTransferMutation = useInitiateAccountTransferMutation();

  const onSubmit = async (values: FormValues) => {
    if (values.accountNumber) {
      try {
        await initiateAccountTransferMutation.mutateAsync({
          clientId,
          managedAccountId,
          fromAccountId: selectedAccountId,
          accountNumber: values.accountNumber,
        });

        setShowSuccessScreen(true);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return {
    data: {
      formBag,
      showSuccessScreen,
      initiateAccountTransferMutation,
    },

    actions: {
      onSubmit,
    },
  };
};
